module.exports = __webpack_public_path__ + "img/1.1e822990.jpg";